'use client';

import { Button, Center } from '@chakra-ui/react';
import { AlertTriangle, RotateCcw } from 'lucide-react';
import { useEffect } from 'react';
import { EmptyState } from '@/components/shared/ui';

export default function AppError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('App route failed', error);
  }, [error]);

  return (
    <Center minH="320px" w="full" px="4" role="alert">
      <EmptyState
        icon={<AlertTriangle />}
        title="This View Couldn’t Load"
        description="The current view hit an unexpected error. Your navigation and project selection are still intact."
        maxW="lg"
        w="full"
        action={
          <Button onClick={reset}>
            <RotateCcw size={16} aria-hidden="true" />
            Try Again
          </Button>
        }
      />
    </Center>
  );
}
